/* Os nomes das constantes precisam ser iguais aos nomes retornados pelo endpoint */

export const PUBLISH_STATUS = {
  DRAFT: 'Rascunho',
  PUBLISHED: 'Publicada',
  SUSPENDED: 'Suspensa',
  IN_VALIDATION: 'Validando dados',
  PENDING: 'Pendente',
  CLOSED: 'Encerrada',
};

export const INSCRICAO_ESTADUAL_STATUS = {
  ACTIVE: 'ATIVA',
  INACTIVE: 'INATIVA',
  NULL: '-',
};

export const ICONS_STATUS = {
  NOT_REGISTERED: 'alert-circle',
  VALID: 'checked',
  INVALID: 'alert-triangule',
  PENDING: 'loading-2',
};

export const CPF_STATUS = {
  NOT_REGISTERED: 'CPF Não Validado',
  PENDING: 'Validando CPF',
  VALID: 'CPF Válido',
  INVALID: 'CPF Inválido',
};

export const CNPJ_STATUS = {
  NOT_REGISTERED: 'CNPJ Não Validado',
  PENDING: 'Validando CNPJ',
  VALID: 'CNPJ Válido',
  INVALID: 'CNPJ Inválido',
};

export const BANK_ACCOUNT_STATUS = {
  NOT_REGISTERED: 'Conta Bancária Não validada',
  NOT_FINISHED: 'Conta Bancária Não validada',
  NOT_VERIFIED: 'Conta Bancária Não validada',
  WAITING_VALIDATION: 'Validando Conta Bancária',
  INVALID: 'Conta Bancária Inválida',
  VALID: 'Conta Bancária Válida',
};

export const SECONDARY_BANK_ACCOUNT_STATUS = {
  NOT_REGISTERED: 'Conta Bancária Não validada',
  NOT_FINISHED: 'Conta Bancária Não validada',
  NOT_VERIFIED: 'Conta Bancária Não validada',
  WAITING_VALIDATION: 'Validando Conta Bancária',
  INVALID: 'Conta Bancária Inválida',
  VALID: 'Conta Bancária Válida',
};

/* ACCOUNT_TYPE */
export const TYPE = {
  CURRENT: 'Conta corrente',
  SAVING: 'Conta poupança',
};

export const ATTACHMENT_STATUS = {
  DISAPPROVED: 'Não aprovado',
  APPROVED: 'Aprovado',
  PENDING: 'Pendente',
};

export const ATTACHMENT_TYPE = {
  CONTRACT: 'Contrato de serviço',
  SANITARY_PERMIT: 'Alvará sanitário',
  OPERATING_PERMIT: 'Autorização de funcionamento',
};

export const BUSINESS_TYPE = {
  RESTAURANT: 'Restaurante',
  PHARMACY: 'Farmácia',
  MARKET: 'Mercado',
  PETSHOP: 'Petshop',
  WATER_AND_GAS: 'Água e Gás',
  OTHER: 'Outros',
};

export const DISPATCH_TYPE = {
  POOL: 'Compartilhado',
  DEDICATED: 'Dedicado',
};

export const DOCUMENT_TYPE = {
  CPF: 'CPF',
  CNPJ: 'CNPJ',
};

export const SERVICE_TYPE = {
  MARKETPLACE: 'Marketplace',
  FULL_SERVICE: 'Fullservice',
};

export const TAX_REGIME = {
  SIMPLE_NATIONAL: 'Simples nacional',
  PRESUMED_REAL_PROFIT: 'Lucro real ou presumido',
  PHYSICAL_PERSON: 'Pessoa física', //Deprecated
};

export const STORE_ORDER_CONFIGURATION = {
  MINIMUM_ORDER_PRICE: 'Pedido mínimo',
  PREPARATION_TIME: 'Tempo de preparo',
  DELIVERY_TIME: 'Tempo de entrega',
};

export const PIX_TYPE = {
  CPF_CNPJ: 'CPF/CNPJ',
  PHONE: 'Telefone',
  EMAIL: 'E-mail',
  RANDOM: 'Chave Aleatória',
};

export const TIMEZONE = {
  'America/Rio_Branco': 'Rio Branco (GMT-5)',
  'America/Boa_Vista': 'Boa Vista (GMT-4)',
  'America/Manaus': 'Manaus (GMT-4)',
  'America/Porto_Velho': 'Porto Velho (GMT-4)',
  'America/Cuiaba': 'Cuiabá (GMT-4)',
  'America/Campo_Grande': 'Campo Grande (GMT-4)',
  'America/Sao_Paulo': 'Brasília (GMT-3)',
  'America/Belem': 'Belém (GMT-3)',
  'America/Araguaina': 'Araguaína (GMT-3)',
  'America/Fortaleza': 'Fortaleza (GMT-3)',
  'America/Recife': 'Recife (GMT-3)',
  'America/Maceio': 'Maceió (GMT-3)',
  'America/Bahia': 'Salvador (GMT-3)',
};
